<ng-container *ngIf="!isRecurringService; else recurring_content">
  <ng-container *ngIf="repeat === 'Weekly'; else one_time_content">
    <ng-container *ngFor="let day of serviceDays">
      <ng-container *ngIf="day.onSchedule">
        <div class="schedule weekly">
          {{ day.displayName }}
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #recurring_content>
  <ng-container *ngIf="repeat === 'Weekly'; else monthly_yearly_content">
    <div class="schedule recurring">
      {{ getRepeatScheduleMsg() }}
    </div>
    <ng-container *ngFor="let day of serviceDays">
      <ng-container *ngIf="day.onSchedule">
        <div class="schedule weekly">
          {{ day.displayName }}
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #monthly_yearly_content>
  <div class="schedule recurring">
    {{ getRepeatScheduleMsg() }}
  </div>
</ng-template>

<ng-template #one_time_content>
  <div class="schedule onetime">N/A</div>
</ng-template>
